module.exports = __webpack_public_path__ + "img/Vehicle_Unselected.46944936.svg";